import { render, staticRenderFns } from "./user-info-record-dialog.vue?vue&type=template&id=58829f14&scoped=true"
import script from "./user-info-record-dialog.vue?vue&type=script&lang=js"
export * from "./user-info-record-dialog.vue?vue&type=script&lang=js"
import style0 from "./user-info-record-dialog.vue?vue&type=style&index=0&id=58829f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58829f14",
  null
  
)

export default component.exports